import { LoadingOutlined, RobotOutlined } from '@ant-design/icons'
import { Button, Tag } from 'antd'
import { type ReactElement, useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { AgentRunningTurnContext } from '../../state/agentWidgetContext'
import { LAUNCHER_STYLE } from './agentWidgetLayout'

// 閉じているときの入口。押したときだけ開き、カーソルを当てただけでは開かない
// （カーソルを当てて開く作りは、右下のセルや Intercom を狙った動きで開いてしまう誤操作が、デモで出たため）。
// 閉じても実行中のターンの読み取りは続くので、実行中はアイコンを回る印に替え、動いていることが閉じたまま分かるようにする
// （仕様の「部品の構成」。承認の要求と、閉じている間に終わったことの印は #10114 で足す）
export const AgentLauncherButton = ({ onOpen }: { onOpen: () => void }): ReactElement => {
  const { t } = useTranslation()
  const isRunning = useContext(AgentRunningTurnContext) !== null

  return (
    <div style={LAUNCHER_STYLE}>
      <Button
        shape="round"
        icon={isRunning ? <LoadingOutlined aria-label={t(`実行中`)} /> : <RobotOutlined />}
        onClick={onOpen}
      >
        {t(`エージェント`)}
        <Tag className="m-0 opacity-80" color="blue">
          {t(`β版`)}
        </Tag>
      </Button>
    </div>
  )
}
